/* eslint-disable no-useless-escape */
const rule = {
  email: /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,  // eslint-disable-line max-len
  mobile: /^[1][0-9]{10}$/,
  password: /^[\w_,.!#@\$%\^&*\(\)\[\]\+\-\\\{\}\|:;''<>\?\/`~]{6,20}$/,
  identity: /^[1-8](\d{14})$|^[1-8](\d{16})[0-9xX]$/,
  number: /^\d+$/,
  qq: /^[1-9]\d{4,10}$/,
  wechat: /^[a-zA-Z][\w\-]{5,19}$/,
}

function isValid(name, value) {
  if ((name in rule) === false) {
    throw Error('Validor not found')
  }
  return rule[name].test(value)
}

export default isValid



// WEBPACK FOOTER //
// ./client/utils/validor.js